import { generateClient } from 'aws-amplify/api';
import { listPosts } from '../graphql/queries'; 
import * as mutations from '../graphql/mutations';

const client = generateClient();

export const fetchJobs = async () => {
  try {
    const result = await client.graphql({ query: listPosts });
    const jobs = result.data.listPosts.items;
    return jobs;
  } catch (error) {
    console.error('Failed to fetch jobs:', error);
    throw error; 
  }
};

export const deleteJob = async (id: string) => {
  try {
    const response = await client.graphql({
      query: mutations.deletePost,
      variables: { input: { id } }
    });

    if (response.data && response.data.deletePost) {
      console.log('Delete response:', response.data.deletePost);
      alert('Job deleted successfully');
    } else {
      console.error('Failed to delete job: No deletePost data');
      alert('Failed to delete job');
    }
  } catch (error) {
    console.error('Delete failed:', error);
    alert('Error during deletion');
  }
};

export const editJob = async (
  id: string,
  title?: string,
  location?: string,
  type?: string,
  description?: string[],
) => {
  const jobDetails = {
    id,
    title,
    location,
    type,
    description,
  };

  try {
    const response = await client.graphql({
      query: mutations.updatePost,
      variables: { input: jobDetails }
    });

    if (response.data && response.data.updatePost) {
      console.log('Edit response:', response.data.updatePost);
      alert('Job updated successfully');
      return response.data.updatePost;
    } else {
      console.error('Failed to update job: No updatePost data');
      alert('Failed to update job');
    }
  } catch (error) {
    console.error('Update failed:', error);
    alert('Error during update');
    throw error; 
  }
};
